module.exports = __webpack_public_path__ + "img/Lion-Tattoo-93-650x650.jpg";